export const mosPropNames = {
  cid: 'Id',
  name: 'Имя',
  phone: 'Телефон',
  email: 'Email',
  number: 'Номер авто',
  passTime: 'Тип',
  'lastPass.series': 'Номер пропуска',
  'lastPass.duration': 'Тип',
  'lastPass.type': 'Зона',
  'lastPass.status': 'Статус',
  'lastPass.createdAt': 'Дата выдачи',
  'lastPass.endsAt': 'Дата окончания',
  ecp: 'ЭЦП',
  considerationTemp: 'Этап (разовый)',
  creatorName: 'Кто делал',
  consideration: 'Этап (годовой)',
  dk: 'ДК',
  additionalInfo: 'Доп информация',
  price: 'Стоимость',
  paymentType: 'Способ расчета',
  paymentStatus: 'Статус оплаты',
  note: 'Комментарий',
  sendSms: 'Смс',
};



// WEBPACK FOOTER //
// ./src/components/pages/clients/dictionaries/prop-names.js